import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=26401591&scoped=true"
import script from "./SideBarItem.vue?vue&type=script&lang=js"
export * from "./SideBarItem.vue?vue&type=script&lang=js"
import style0 from "./SideBarItem.vue?vue&type=style&index=0&id=26401591&prod&scoped=true&lang=scss"
import style1 from "./SideBarItem.vue?vue&type=style&index=1&id=26401591&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26401591",
  null
  
)

export default component.exports